import { render, staticRenderFns } from "./ViewAdditionalCostRevenue.vue?vue&type=template&id=013ce720"
import script from "./ViewAdditionalCostRevenue.vue?vue&type=script&lang=js"
export * from "./ViewAdditionalCostRevenue.vue?vue&type=script&lang=js"
import style0 from "./ViewAdditionalCostRevenue.vue?vue&type=style&index=0&id=013ce720&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports